import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom, topMessageAtom, myNftAtom, myNftBackAtom } from '../../State';
import { useRecoilValue, useRecoilState } from 'recoil';
import { ReactComponent as RightArrowSVG } from '../Images/buttons/rightArrow.svg';
import NFT from '../NFT/NFT';
import '../HairCheck/HairCheck.css';
import Live2dWrap from '../Live2d/Live2dWrap';
import Header from '../Header/Header';
import isElectron from '../../Global';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import Tray from '../Tray/Tray';
import Media from '../Media/Media';
import Resize from '../Live2d/Resize';
import NFTDetail from '../NFT/NFTDetail';
import NFTBack from '../NFT/NFTBack';
import FaceImage from '../Setting/FaceImage';
import { getImagePath } from '../Util/utils';

export default function ElectronFace({ setShowJoin }) {
  const defaultBack = 'whiteYellow.png';

  const { t } = useTranslation();
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const myNftBackState = useRecoilValue(myNftBackAtom);
  const [backState, setBackState] = useState(null);

  let divClass;
  if (isElectron) {
    divClass = 'appElectron';
  } else if (isMobile) {
    divClass = 'isMobile';
  } else {
    divClass = 'appElectron';
  }

  useEffect(() => {
    setTimeout(() => {
      loadBack();
    }, 200);
  }, [myNftBackState]);

  //Load background image
  async function loadBack() {
    var finalURL;

    if (localStorage.getItem('backImageURL') != null) {
      finalURL = localStorage.getItem('backImageURL');
    } else {
      if (myNftBackState == null) {
        finalURL = defaultBack;
      } else {
        finalURL = myNftBackState;
      }
    }

    try {
      //カスタム背景の場合
      if (finalURL.startsWith('custom')) {
        let baseURL = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/mybackground/';
        finalURL = baseURL + finalURL;
      } else if (finalURL == 'h4.jpg') {
        finalURL = 'https://faceless.hiho.jp/background/back.png';
      } else {
        finalURL = getImagePath() + '/background/' + finalURL;
      }

      setBackState(finalURL);
    } catch (e) {
      setBackState(null);
    }
  }

  async function tapAvatar() {
    setPageState('nftList');
  }

  async function tapBackground() {
    setPageState('background');
  }

  //レンダー
  return (
    <>
      {/* リサイズ中表示 */}
      <Resize />
      <Media />
      <div className={divClass}>
        <div id="headerBlack"></div>
        <Header url={'dd'} isHairCheck={true} showSettingButton={false} />
        {pageState == 'nftList' && <NFT />}

        {/*NFT詳細画面*/}
        {pageState == 'nftDetail' && <NFTDetail />}
        {/*背景*/}
        {pageState == 'background' && <NFTBack />}

        <div className="call">
          <Live2dWrap isHairCheck={true} isFaceScreen={true} />

          <div
            id="hairCheckWrap"
            style={{ bottom: '30px', opacity: pageState == 'nftList' ? 0.2 : 1 }}>
            <div className="faceWrapBox">
              <div className="faceWrapBoxTitle">{t('mypage.Brand your space')}</div>
              <div className="faceWrapBoxBody">
                {t('mypage.Welcome your guests to your branded area.')}
              </div>
              <div className="faceWrapButton" onClick={tapAvatar}>
                <FaceImage myNftState={myNftState} />
                <div>{t('mypage.Select Avatar')}</div>
                <RightArrowSVG />
              </div>

              <div className="faceWrapButton" onClick={tapBackground}>
                <img src={backState} style={{ borderRadius: '5px', height: '30px' }} />
                <div>{t('mypage.Select Background')}</div>
                <RightArrowSVG />
              </div>
            </div>
          </div>
        </div>

        <Tray isFaceScreen={true} />
      </div>

      {isMobile && (
        <div id="mobileFaceBottom">
          <button
            onClick={() => {
              setPageState('nftList');
            }}>
            {t('mypage.Change Avatar')}
          </button>
        </div>
      )}
    </>
  );
}
